import { BrandMark } from "../components/BrandMark";
import { useContactFields } from "../components/ContactFields";
import type { CachedContact } from "../lib/types";

interface Props {
  initial: CachedContact | null;
  submitting: boolean;
  onJoin: (
    payload: {
      contactName: string | null;
      email: string | null;
      phone: string | null;
      zip: string | null;
      marketingOptIn: boolean;
    },
    display: CachedContact,
  ) => void;
  onSkip: () => void;
}

export function WelcomeScreen({ initial, submitting, onJoin, onSkip }: Props) {
  const contact = useContactFields(initial);

  const submit = () => {
    if (!contact.isValid || submitting) return;
    onJoin(contact.payload, contact.display);
  };

  return (
    <main className="shell flex flex-col px-6 pb-8 pt-10">
      <header className="mb-6 flex justify-center">
        <BrandMark className="h-14 w-auto" />
      </header>

      <div className="flex flex-1 flex-col">
        <p className="mb-2 text-xs uppercase tracking-[0.3em] text-amber">Welcome</p>
        <h1 className="text-4xl text-cream">Join the club.</h1>
        <p className="mt-3 text-cream-dim">
          Rate all 4 sauces and you're entered to win a free meal for two.
        </p>

        <div className="mt-6">{contact.fields}</div>
      </div>

      <div className="mt-6 flex flex-col gap-3">
        <button
          type="button"
          disabled={!contact.isValid || submitting}
          onClick={submit}
          className="pill-btn pill-btn-primary"
        >
          {submitting ? "Sending…" : "Continue"}
        </button>
        <button
          type="button"
          onClick={onSkip}
          disabled={submitting}
          className="text-sm text-cream-dim underline-offset-4 hover:underline disabled:opacity-50"
        >
          Skip, just let me rate
        </button>
      </div>
    </main>
  );
}
